import React, {ReactNode} from "react";
import {Badge} from "@fluentui/react-components";

interface AppBadgeProps {
    children: ReactNode;
}

export default function AppBadge({children}: Readonly<AppBadgeProps>) {
    return (
        <Badge appearance="outline" color="informative" size="medium" style={{borderRadius: '6px'}}>
            {children}
        </Badge>
    );
}